import queryString from 'qs';

export const getLiveAccountRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.brand?.length) queries['brands.name'] = `[${queryParams?.brand?.map((item) => item?.value)}]`;
  if (queryParams?.platform?.length) queries['ecommerce.id'] = `[${queryParams?.platform?.map((item) => item?.value)}]`;
  if (queryParams?.accountType?.length) queries['accountType.name'] = `[${queryParams?.accountType?.map((item) => item?.value)}]`;
  if (queryParams?.search) queries['search'] = queryParams?.search;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getLiveAccountRequest;
